import { useState } from "react";

import { Box, Typography } from "@mui/material";

import { IUser } from "../../../../../interfaces/IUser";

import Button from "../../../../../components/Button";
import { ConfirmationDialog } from "../../../../../components/ConfirmationDialog";
import DataGrid from "../../../../../components/DataGrid";

import useDeleteUser from "../../../../../hooks/AcessApi/useDeleteUser";
import useUsers from "../../../../../hooks/AcessApi/useUsers";

import { GridColDef, useGridApiRef } from "@mui/x-data-grid";

export const DeleteUserList = () => {
    const [openConfirmDeleteUserDialog, setOpenConfirmDeleteUserDialog] =
        useState(false);

    const { data: users, isFetching: gettingUsers } = useUsers();

    const { mutate: deleteUser, isLoading: deletingUser } = useDeleteUser();

    const UsersGridRef = useGridApiRef();
    const [usersGridColumnDefs] = useState<GridColDef<IUser>[]>([
        {
            field: "username",
            headerName: "Nome",
            flex: 1,
        },
    ]);

    const handleDeleteUser = () => {
        const selectedUsers = UsersGridRef.current.getSelectedRows();
        const selectedUsersArray = Array.from(
            selectedUsers.values()
        ) as IUser[];
        const usernames = selectedUsersArray
            ?.map((user) => user.username)
            .filter((user) => typeof user === "string") as string[];
        deleteUser(usernames[0]);
    };

    const isLoading = gettingUsers || deletingUser;

    return (
        <Box>
            <Typography sx={{ marginBottom: "5px" }} variant="h4">
                Excluir Usuário
            </Typography>
            <Box width={"100%"} height={"300px"}>
                <DataGrid<IUser>
                    apiRef={UsersGridRef}
                    columns={usersGridColumnDefs}
                    rows={users ? users : []}
                    isRowSelectable={() => true}
                    checkboxSelection
                    loading={isLoading}
                />
            </Box>
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "end",
                }}
            >
                <Button
                    onClick={() => setOpenConfirmDeleteUserDialog(true)}
                    loading={deletingUser}
                >
                    <Typography variant="body2">Deletar</Typography>
                </Button>
            </Box>
            {openConfirmDeleteUserDialog && (
                <ConfirmationDialog
                    title="Deseja mesmo deletar o usuário?"
                    message="Caso confirme o usuário perderá acesso a todos os sistemas da frexco."
                    openDialog={openConfirmDeleteUserDialog}
                    setOpenDialog={setOpenConfirmDeleteUserDialog}
                    callback={handleDeleteUser}
                />
            )}
        </Box>
    );
};
